module.exports = __webpack_public_path__ + "img/add-customer.ddf0579f.svg";